import {LEAGUES} from "../constants/leagues";
import {UNITS_SAME_TIME_COUNT_LIMIT} from "./units";
import {getLocalBotLeagueId} from "./localBotLeagues";

/**
 * Волна 38: общий потолок армии бота — по его лиге (решение владельца 29.10).
 *
 * Откуда. В правилах игры лимит 4 — на отряды ОДНОГО типа
 * (UNITS_SAME_TIME_COUNT_LIMIT, коммит 0a47f3157 «units of same type limit»),
 * а первый код ботов (4625532e9, 17.07) прочитал его как общий лимит всей армии:
 * при любых 4 отрядах новый не нанимался. Обоснования у этого потолка не было
 * никогда — у живого игрока и у ИИ-агентов через MCP общего лимита нет. Волны
 * 27, 31 и 37 обходили его точечными слотами; у ботов золото+ в R9–12 найм
 * упирался в него в 70–76% этапов (отчет 35, §1.1).
 *
 * Лига бота (getBotArmyCapLeagueId):
 *  - явный бот рейтинга (isVisibleBot) — его лига (player.leagueId);
 *  - бот локальной партии (isLocalBot) — лига-эквивалент выбранного ему бонуса
 *    (configs/localBotLeagues);
 *  - неявный бот и игрок, за которого ходит бот, — лиги нет, прежний потолок 4.
 *
 * Сверх потолка по-прежнему действуют точечные слоты фракций (волны 27/31) и
 * слоты волны 37 (T, F); фермерский потолок и лимит правил по типу не меняются.
 * Применение — utils/bots/getBotArmyCap (A/B-гейты волны 38).
 */
export const BOT_ARMY_CAP_BY_LEAGUE = {
  [LEAGUES.BRONZE]: UNITS_SAME_TIME_COUNT_LIMIT,
  [LEAGUES.SILVER]: 5,
  [LEAGUES.GOLD]: 6,
  [LEAGUES.DIAMOND]: 8,
  [LEAGUES.RUBY]: 10,
  [LEAGUES.GOD]: 12,
};

// Лига бота для потолка армии; null — неявный бот или не бот (потолок прежний)
export const getBotArmyCapLeagueId = (player) => {
  if (!player) {
    return null;
  }
  if (player.isVisibleBot) {
    return player.leagueId || null;
  }
  if (player.isLocalBot) {
    return getLocalBotLeagueId(player.bonus);
  }
  return null;
};

// Общий потолок армии бота по его лиге; без лиги — UNITS_SAME_TIME_COUNT_LIMIT
export const getBotLeagueArmyCap = (player) => (
  BOT_ARMY_CAP_BY_LEAGUE[getBotArmyCapLeagueId(player)] || UNITS_SAME_TIME_COUNT_LIMIT
);
